import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "angular-toastify";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { MaterialType } from "@enums/materialType.enum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { PurchasableItem } from "@interfaces/purchasableItem.interface";
import { PurchasableItemService } from "@services/purchasableItem.service";
import { StockStoreService } from "@services/stockStore.service";

@Component({
	moduleId: module.id,
	selector: "purchasableItems-id",
	styleUrls: ["purchasableItems-id.css"],
	templateUrl: "purchasableItems-id.html"
})
export class PurchasableItemsIdAdminComponent {
	activeProcessIds: number[] = [];
	createEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	item: PurchasableItem = new PurchasableItem();
	itemId = 0;
	itemType = "Purchasable Item";
	items: any[] = [];
	materialTypes: any;
	purchaseTypes: any;
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	statuses: any;
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: PurchasableItemService, private stockStoresService: StockStoreService) {
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.materialTypes = GetPropertiesFromEnum(MaterialType);
		this.buildButtons("view");
		this.viewRow = this.viewRow.bind(this);

		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0]);
						this.edit();
					} else {
						this.getItem(params.id);
					}
				} else {
					this.create();
				}
			});
	}

	buildButtons(mode: string) {
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.item = new PurchasableItem();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "purchaseType":
				if (this.item.purchaseType !== PurchaseTypeEnum.Material && this.item.purchaseType !== PurchaseTypeEnum.ToolingBillet) {
					this.item.materialType = MaterialType.NotApplicable;
				}
				break;
		}
	}

	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.getItems(itemId);
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getItems(itemId: number) {
		this.stockStoresService.getByItemId(itemId)
			.subscribe(
				(res: any) => this.items = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => { this.toastService.success("Successfully Updated"); },
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	
	viewRow(e: any) {
		this.router.navigate([`admin/stores/${e.row.data.id}`]);
	}
}